export default {
  attach: function () {},
  detach: function () {}
};